import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
    row: {
        padding: "4px 0",
    },
    label: {
        color: theme.palette.text.secondary,
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        fontSize: "10.5px",
        fontWeight: 500,
    },
}));

export function humanizeKey(key: string): string {
    const spaced = key.replace(/([a-z0-9])([A-Z])/g, "$1 $2");
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function formatValue(value: unknown): string {
    if (value === null || value === undefined || value === "") {
        return "—";
    }
    if (typeof value === "boolean") {
        return value ? "Yes" : "No";
    }
    if (Array.isArray(value)) {
        return value.length > 0 ? value.map(String).join(", ") : "—";
    }
    if (typeof value === "object") {
        return JSON.stringify(value);
    }
    return String(value);
}

interface Props {
    fields: Record<string, unknown>;
    renderValue?: (key: string, value: unknown) => string | undefined;
}

export const DynamicFieldsList: React.FC<Props> = ({ fields, renderValue }) => {
    const classes = useStyles();
    const keys = Object.keys(fields);

    if (keys.length === 0) {
        return null;
    }

    return (
        <Grid container spacing={1}>
            {keys.map((key) => (
                <Grid item xs={12} sm={6} key={key} className={classes.row}>
                    <Typography variant="caption" className={classes.label} component="div">
                        {humanizeKey(key)}
                    </Typography>
                    <Typography variant="body2">
                        {renderValue?.(key, fields[key]) ?? formatValue(fields[key])}
                    </Typography>
                </Grid>
            ))}
        </Grid>
    );
};
